<template>
  <div id="nav" class="w">
    <en-category/>
    <ul class="nav-list">
      <li v-for="nav in this.$store.getters.navList" :key="nav.navigation_id">
        <a v-if="nav.url.indexOf('http') == 0" :href="nav.url" target="_self">{{ nav.navigation_name }}</a>
        <router-link v-else :to="nav.url">{{ nav.navigation_name }}</router-link>
      </li>
<!--      <li>-->
<!--        <a v-if=flag href="/purchase" >采购单</a>-->
<!--      </li>-->
    </ul>
  </div>
</template>

<script>
  import { parse, stringify } from 'querystring'
  export default {
    name: 'EnNav',
    data() {
      return {
        // 显示采购单按钮
        // flag: process.env.flag,
        navList: [
          {
            'navigation_id': '',
            'navigation_name': '秒杀',
            'url': '/bargains-for-seconds',
            'client_type': 'PC',
            'image': '',
            'sort': '7'
          },
          {
            'navigation_id': '60',
            'navigation_name': '优惠券',
            'url': '/coupons',
            'client_type': 'PC',
            'image': '',
            'sort': '18'
          },
          {
            'navigation_id': '27',
            'navigation_name': '格桑超市',
            'url': '/goods?keyword=男装',
            'client_type': 'PC',
            'image': '',
            'sort': '6'
          },
          {
            'navigation_id': '26',
            'navigation_name': '艳阳集市',
            'url': '/goods?keyword=女装',
            'client_type': 'PC',
            'image': '',
            'sort': '5'
          },
          {
            'navigation_id': '25',
            'navigation_name': '企业采购',
            'url': '/goods?keyword=数码家电',
            'client_type': 'PC',
            'image': '',
            'sort': '4'
          },
          {
            'navigation_id': '24',
            'navigation_name': '非遗文创',
            'url': '/group-buy',
            'client_type': 'PC',
            'image': '',
            'sort': '3'
          }
        ]
      }
    },
    mounted() {
      // console.log("mounted");
      // console.log(this.$store.getters.navList);

    },
    methods: {
      getUrl(url) {
        if (/keyword=(.*)/.test(url)) {
          let querys = url.match(/\?(.*)/)
          const query = parse(querys[1])
          const qs = stringify(query)
          url = url.replace(/\?(.*)/, `?${qs}`)
        }
        return url
      }
    }
  }
</script>

<style type="text/scss" lang="scss" scoped>
  @import "../assets/styles/color";
  #nav {
    display: flex;
    height: 40px;
    .nav-list {
      overflow: hidden;
      max-width: calc(1210px - 240px);
      li {
        vertical-align: top;
        letter-spacing: normal;
        word-spacing: normal;
        display: inline-block;
        a {
          font-size: 20px;
          line-height: 40px;
          color: #333;
          height: 40px;
          padding: 0 24px;
          display: inline-block;
          zoom: 1;
          font-weight: 500;
          &:hover {
            color: $color-main
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Nav.vue